import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import DetailsTable from "../../common/DetailsTable";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import {
  handleConcursosDetailError,
  handleLoadingConcursoError,
} from "../../utils/errors";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialog: {
    "& .MuiDialog-paper": {
      maxWidth: "700px",
    },
  },
  tooltip: {
    fontSize: "14px",
    fontWeight: "normal",
  },
}));

export default function DraftSendModal(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState({});
  const [openSpinner, setOpenSpinner] = React.useState(false);

  const handleOpen = (event) => {
    setOpen(!open);
  };

  const handleError = (error) => {
    setOpen(false);
    setOpenSpinner(false);
    handleConcursosDetailError(error);
  };

  const handleClick = () => {
    setOpenSpinner(true);
    axios
      .post(window.ENV.API_URL + "/concursosBorrador/" + props.concursoId + "/")
      .then((res) => {
        handleOpen();
        setOpenSpinner(false);
        window.location.reload();
      })
      .catch((error) => handleError(error));
  };

  const handleOpenModal = () => {
    setOpenSpinner(true);
    axios
      .get(window.ENV.API_URL + "/concursos/" + props.concursoId + "/")
      .then((res) => {
        setData(res.data[0]);
        handleOpen();
        setOpenSpinner(false);
      })
      .catch((error) => handleError(error));
  };

  return (
    <Fragment>
      {/*
      <Button
        startIcon={<SendIcon />}
        color="primary"
        onClick={handleOpenModal}
      >
        {props.label}
      </Button>*/}
      <Tooltip
        onClick={handleOpenModal}
        title={<span className={classes.tooltip}>{props.label}</span>}
      >
        <IconButton>
          <SendIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleOpen}
        scroll={"paper"}
        className={classes.dialog}
        fullWidth
      >
        <DialogTitle>Solicitud de concurso</DialogTitle>
        <DialogContent dividers={true}>
          <div className="text-center">
            ¿Desea solicitar la aprobación del siguiente concurso?
          </div>
          <DetailsTable data={data} />
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            style={{ marginRight: "1em" }}
            variant="contained"
            onClick={handleOpen}
          >
            Cancelar
          </Button>
          <Button
            disableElevation
            color="primary"
            variant="contained"
            onClick={handleClick}
          >
            Solicitar aprobación
          </Button>
        </DialogActions>
        <Backdrop className={classes.backdrop} open={openSpinner}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openSpinner}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
}
